"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateMarkdownItAttrs;

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function updateMarkdownItAttrs(token, updater) {
  return (0, _simpleUpdateIn.default)(token, ['attrs'], function (attrs) {
    var map = Object.fromEntries(attrs);
    var nextMap = updater(map);
    return Object.entries(nextMap);
  });
}